import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex flex-col h-screen"
};
const _hoisted_2 = { class: "flex flex-col flex-1 pb-4 overflow-auto" };
const _hoisted_3 = {
    key: 0,
    class: "flex flex-col flex-1 min-h-0 text-sm sm:pt-20 sm:mx-5"
};
const _hoisted_4 = {
    key: "time",
    class: "flex flex-col items-center text-sm sm:pt-20 sm:mx-5"
};
const _hoisted_5 = {
    key: "activity",
    class: "relative flex flex-col items-center flex-1 min-h-0 overflow-y-auto text-sm sm:pt-20 sm:mx-5"
};
const _hoisted_6 = {
    key: "advanced",
    class: "flex flex-col items-center text-sm sm:pt-20 sm:mx-5"
};
const _hoisted_7 = {
    key: 0,
    class: "flex"
};
const _hoisted_8 = {
    key: 1,
    class: "flex"
};
const _hoisted_9 = ["onSubmit"];
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('views.retro.new')
};
import { computed, watch, onMounted, ref, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { useFullWidth } from '@/composables/useFullWidth';
import { useWorkspaceAndTeam } from '@/composables/workspaces';
import { useConstantStore } from '@/pinia_stores/constant';
import WorkspaceSubheader from '@/components/workspaces/WorkspaceSubheader.vue';
import PricingModal from '@/components/pricing/PricingModal.vue';
import ActivityPicker from '@/components/new/ActivityPicker.vue';
import AdvancedOptions from '@/components/new/AdvancedOptions.vue';
import DateTimePicker from '@/components/new/DateTimePicker.vue';
import MobileNotSupported from '@/components/MobileNotSupported.vue';
import NumberStepper from '@/components/progress/NumberStepper.vue';
import ParticipantsPicker from '@/components/new/ParticipantsPicker.vue';
import ProgressBar from '@/components/progress/ProgressBar.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import UnlockMoreActivitiesDialog from '@/components/workspaces/UnlockMoreActivitiesDialog.vue';
import transitions from '@/helpers/transitions';
import constants, { FEATURE_FLAGS } from '@/constants';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'New',
    setup(__props) {
        useFullWidth();
        const { fade } = transitions;
        const { fadeIn, fadeOut } = fade;
        const store = useStore();
        const constantStore = useConstantStore();
        const { team, workspace } = useWorkspaceAndTeam({ loadFullWorkspace: true });
        const isPricingEnabled = FEATURE_FLAGS.PRICING_ENABLED;
        const areActivitiesLoaded = ref(false);
        const loading = ref(false);
        const isPricingModalOpen = ref(false);
        const isUnlockMoreActivitiesDialogVisible = ref(false);
        const isLoading = ref(false);
        const selectedPaymentPeriod = ref('annual');
        const isVisible = computed(() => {
            return workspace.value && team.value && areActivitiesLoaded.value;
        });
        const isFreeWorkspace = computed(() => store.getters.isFreeWorkspace);
        const session = computed(() => store.getters.session);
        const isDarkMode = computed(() => store.getters.isDarkMode);
        const isWorkspaceOwner = computed(() => store.getters.isWorkspaceOwner);
        const showUnlockMoreActivitiesDialog = () => {
            isUnlockMoreActivitiesDialogVisible.value = true;
        };
        const hideUnlockMoreActivitiesDialog = () => {
            isUnlockMoreActivitiesDialogVisible.value = false;
        };
        onMounted(async () => {
            await constantStore.loadActivities();
            areActivitiesLoaded.value = true;
            store.commit('newRetro/addParticipantId', session.value.id);
            setDefaultTimingOptions();
        });
        onUnmounted(() => {
            store.commit('newRetro/resetState');
        });
        watch(team, () => {
            if (team.value) {
                store.commit('newRetro/updateTeamId', team.value.id);
                const memberIds = store.getters.team.members.map((m) => m.id);
                memberIds.forEach((id) => store.commit('newRetro/addParticipantId', id));
            }
        });
        const duration = computed(() => store.state.newRetro.duration);
        const selectedActivity = computed(() => store.state.newRetro.selectedActivity);
        const participantSlots = computed(() => store.getters['newRetro/participantSlots']);
        const currentStep = computed(() => store.getters['newRetro/currentStep']);
        const isFirstStep = computed(() => store.getters['newRetro/isFirstStep']);
        const isLastStep = computed(() => store.getters['newRetro/isLastStep']);
        const isNextStepDisabled = computed(() => store.getters['newRetro/isNextStepDisabled']);
        const nextStepDisabledReason = computed(() => store.getters['newRetro/nextStepDisabledReason']);
        const stepNumber = computed(() => store.getters['newRetro/stepNumber']);
        const steps = computed(() => store.getters['newRetro/steps']);
        const isActivityStep = computed(() => store.getters['newRetro/isActivityStep']);
        const userListSlots = computed(() => participantSlots || 0);
        const buttonType = computed(() => (isDarkMode.value ? 'primary' : 'secondary'));
        watch(duration, () => {
            setDefaultTimingOptions();
        });
        watch(participantSlots, () => {
            setDefaultTimingOptions();
        });
        const handleNextStep = () => {
            const isSelectedActivityFree = constantStore.activitiesMap.get(selectedActivity.value)?.isFree;
            if (isActivityStep.value &&
                isPricingEnabled &&
                isFreeWorkspace.value &&
                !isSelectedActivityFree) {
                if (isWorkspaceOwner.value) {
                    isPricingModalOpen.value = true;
                }
                else {
                    showUnlockMoreActivitiesDialog();
                }
            }
            else {
                store.commit('newRetro/incrementStep');
            }
        };
        async function handlePlanChoice(plan) {
            const paymentPeriod = plan === 'free' ? null : selectedPaymentPeriod.value;
            try {
                isLoading.value = true;
                await store.dispatch('changePlan', { plan, paymentPeriod });
                isLoading.value = false;
                isPricingModalOpen.value = false;
                store.dispatch('flashThenClear', { message: 'plan_changed' });
                store.commit('newRetro/incrementStep');
            }
            catch (error) {
                store.dispatch('flashThenClear', { message: 'workspace_update_failure' });
            }
        }
        const handleCreateRetro = () => {
            loading.value = true;
            store.dispatch('newRetro/createRetro').then(() => {
                loading.value = false;
            });
        };
        const setDefaultTimingOptions = () => {
            store.commit('newRetro/updateRetroWritingDuration', Math.max(constants.MINIMUM_WRITING_DURATION, Math.floor(duration.value * constants.DEFAULT_WRITING_RATIO)));
            store.commit('newRetro/updateRetroPostingDuration', constants.DEFAULT_TURN_DURATION * participantSlots.value);
        };
        const decrementStep = () => {
            store.commit('newRetro/decrementStep');
        };
        return (_ctx, _cache) => {
            const _component_section_heading = _resolveComponent("section-heading");
            const _component_transition_a11y = _resolveComponent("transition-a11y");
            const _component_text_button = _resolveComponent("text-button");
            const _component_pill_button = _resolveComponent("pill-button");
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_unref(isVisible))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(UnlockMoreActivitiesDialog, {
                        "is-visible": isUnlockMoreActivitiesDialogVisible.value,
                        onConfirm: hideUnlockMoreActivitiesDialog
                    }, null, 8, ["is-visible"]),
                    _createVNode(WorkspaceSubheader, { class: "mt-10" }),
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_transition_a11y, {
                            class: "flex flex-col",
                            css: false,
                            onEnter: _unref(fadeIn),
                            onLeave: _unref(fadeOut)
                        }, {
                            default: _withCtx(() => [
                                (_unref(currentStep) === 'participants')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        _createVNode(_component_section_heading, {
                                            heading: _ctx.$t('participants_picker.title'),
                                            subheading: _ctx.$t('participants_picker.subtitle')
                                        }, null, 8, ["heading", "subheading"]),
                                        _createVNode(ParticipantsPicker)
                                    ]))
                                    : (_unref(currentStep) === 'time')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                            _createVNode(_component_section_heading, {
                                                heading: _ctx.$t('time.title')
                                            }, null, 8, ["heading"]),
                                            _createVNode(DateTimePicker)
                                        ]))
                                        : (_unref(currentStep) === 'activity')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                _createVNode(_component_section_heading, {
                                                    heading: _ctx.$t('activity.title'),
                                                    subheading: _ctx.$t('activity.subtitle')
                                                }, null, 8, ["heading", "subheading"]),
                                                _createVNode(ActivityPicker, { "participant-slots": _unref(userListSlots) }, null, 8, ["participant-slots"]),
                                                _createVNode(PricingModal, {
                                                    "is-open": isPricingModalOpen.value,
                                                    "onUpdate:is-open": _cache[0] || (_cache[0] = ($event) => ((isPricingModalOpen).value = $event)),
                                                    "payment-period": selectedPaymentPeriod.value,
                                                    "onUpdate:payment-period": _cache[1] || (_cache[1] = ($event) => ((selectedPaymentPeriod).value = $event)),
                                                    title: _ctx.$t('plan_modal_title'),
                                                    loading: isLoading.value,
                                                    class: "z-5",
                                                    onChoice: handlePlanChoice
                                                }, null, 8, ["is-open", "payment-period", "title", "loading"])
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                _createVNode(_component_section_heading, {
                                                    heading: _ctx.$t('advanced.title'),
                                                    subheading: _ctx.$t('advanced.subtitle')
                                                }, null, 8, ["heading", "subheading"]),
                                                _createVNode(AdvancedOptions)
                                            ]))
                            ], undefined, true),
                            _: 1
                        }, 8, ["onEnter", "onLeave"])
                    ]),
                    _createVNode(ProgressBar, {
                        class: "hidden sm:flex",
                        "data-cy": "bottom-bar"
                    }, {
                        left: _withCtx(() => [
                            _createVNode(NumberStepper, {
                                "current-step": _unref(stepNumber),
                                steps: _unref(steps).map((step, index) => {
                                    return { number: index + 1, title: _ctx.$t(`steps.${step}`) };
                                })
                            }, null, 8, ["current-step", "steps"])
                        ]),
                        right: _withCtx(() => [
                            (loading.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createVNode(SvgIcon, {
                                        name: "ellipsis",
                                        class: "w-10 h-10 text-white"
                                    })
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    (!_unref(isFirstStep))
                                        ? (_openBlock(), _createBlock(_component_text_button, {
                                            key: 0,
                                            class: "mr-8",
                                            inverted: "",
                                            onClick: decrementStep
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('controls.previous')), 1)
                                            ], undefined, true),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true),
                                    (!_unref(isLastStep))
                                        ? _withDirectives((_openBlock(), _createBlock(_component_pill_button, {
                                            key: 1,
                                            class: "min-w-40",
                                            kind: _unref(buttonType),
                                            disabled: _unref(isNextStepDisabled),
                                            onClick: handleNextStep
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('controls.next')), 1)
                                            ], undefined, true),
                                            _: 1
                                        }, 8, ["kind", "disabled"])), [
                                            [_directive_tooltip, _unref(nextStepDisabledReason) ? _ctx.$t(_unref(nextStepDisabledReason)) : null]
                                        ])
                                        : _createCommentVNode("", true),
                                    (_unref(isLastStep))
                                        ? (_openBlock(), _createElementBlock("form", {
                                            key: 2,
                                            class: "min-w-40",
                                            onSubmit: _withModifiers(handleCreateRetro, ["prevent"])
                                        }, [
                                            _withDirectives((_openBlock(), _createBlock(_component_pill_button, {
                                                kind: _unref(buttonType),
                                                type: "submit",
                                                disabled: _unref(isNextStepDisabled),
                                                "data-cy": "createRetro"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('controls.submit')), 1)
                                                ], undefined, true),
                                                _: 1
                                            }, 8, ["kind", "disabled"])), [
                                                [_directive_tooltip, _unref(nextStepDisabledReason) ? _ctx.$t(_unref(nextStepDisabledReason)) : null]
                                            ])
                                        ], 40, _hoisted_9))
                                        : _createCommentVNode("", true)
                                ]))
                        ]),
                        _: 1
                    }),
                    _createVNode(MobileNotSupported)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
